import Panel from '../../common/layout/Panel'
import DataResource from '../../common/v4/DataResource';

const ResellersList = () => {
    const data = {
        url: '/admin/resellers/resellers',
        data: {
            data: [],
            metadata: []
        },
        userFilterExpandable: false,
        onclick: 'link',
        link: '/resellers/resellers/{id}',
        metadata: [
            {
                source: 'ATRRESELLERID',
                label: 'Reseller ID',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                source: 'ATRNAME',
                label: 'Name',
                type: 'text',
            },
            {
                source: 'ATREMAIL',
                label: 'Email',
                type: 'text',
            },
            {
                source: 'ATRSTATUS',
                label: 'Enabled',
                type: 'boolean',
            },
            {
                type: 'delete',
                label: 'Delete',
            }
        ]
    }
    return (
       <Panel title = "Resellers">
            <DataResource
                addButtonText = "Create Reseller"
                addButtonLink = "/resellers/resellers/create"                    
                data = {data}

            />
        </Panel>
    )
}

export default ResellersList;